import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import type { BreadcrumbItem } from './anc-breadcrumb.model';

/**
 * Presentational breadcrumb trail — Figma New-Library node 1876:13447.
 *
 * Projected content (`ng-content`) renders after the last crumb — e.g. an
 * info icon next to the current page's label.
 *
 * @example
 * <lib-anc-breadcrumb
 *   [items]="breadcrumbItems"
 *   [moduleIcon]="moduleIcon"
 * />
 */
@Component({
    selector: 'lib-anc-breadcrumb',
    imports: [CommonModule, RouterModule, TranslateModule],
    templateUrl: './anc-breadcrumb.component.html',
    styleUrls: ['./anc-breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncBreadcrumbComponent {
    /** Trail segments; the last item is rendered as the current page (not a link). */
    items = input<BreadcrumbItem[]>([]);

    /** Primary module icon class (e.g. `icon-box-copy`) — shown before the first crumb, no chevron. */
    moduleIcon = input<string | undefined>(undefined);

    /**
     * Stable track key for {@link @for} — avoids inline expressions that break Ivy compilation.
     */
    trackBreadcrumbItem(index: number, item: BreadcrumbItem): string {
        const route =
            typeof item.route === 'string'
                ? item.route
                : Array.isArray(item.route)
                ? item.route.join('/')
                : '';

        return `${index}|${item.label}|${route}`;
    }
}
